var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrevious(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 45,
    viewBox: "0 0 26 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.02476 19.7993L20.8243 -0.000152588L25.7733 4.94884L8.44825 22.2739L25.7733 39.5989L20.8243 44.5479L1.02476 24.7484C0.368607 24.092 1.90735e-06 23.2019 1.90735e-06 22.2739C1.90735e-06 21.3458 0.368607 20.4557 1.02476 19.7993Z",
    fill: "#1F4D3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevious);
export default __webpack_public_path__ + "static/media/previous.c5681ec556bdfa849a96fdc43cdef1c3.svg";
export { ForwardRef as ReactComponent };